module.exports = __webpack_public_path__ + "media/images/lb/428-0bc0fb5fd660fcf9c24bd7f880a9cc9d.svg";